import * as React from 'react';
import {
  Edit,
  TabbedForm,
  FormTab,
  TextInput,
  NumberInput,
  SelectInput,
  DateInput,
  required,
  ImageInput,
  ImageField,
  FileInput,
  FileField,
  BooleanInput,
  useDataProvider,
  Toolbar,
  SaveButton,
  DeleteButton,
  useInput,
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import clsx from 'clsx';

const useStyles = makeStyles({
  inline: {
      display: 'inline-block',
      marginLeft: '1em',
      '&.first-child': {
          marginLeft: 0,
      },
  },
});

const LessonEditToolbar = props => {
  const {record, pristine, validating} = props;

  const usName = useInput({source: 'enus_name'});
  const esName = useInput({source: 'es_name'});
  const huName = useInput({source: 'hu_name'});
  const brName = useInput({source: 'ptbr_name'});

  const usVideo = useInput({source: 'enus_video'});
  const esVideo = useInput({source: 'es_video'});
  const huVideo = useInput({source: 'hu_video'});
  const brVideo = useInput({source: 'ptbr_video'});
  
  const translations = [usName.input.value, esName.input.value, huName.input.value, brName.input.value];
  const videos = [usVideo.input.value, esVideo.input.value, huVideo.input.value, brVideo.input.value];
  const hasAllTranslations = translations.every((item) => !!item);
  const hasAllVideos = videos.every((item) => !!item);

  const label = record.blocked ? 'PUBLISH' : 'BLOCK';
  const disabled = !(!pristine && !validating);

  return (
    <Toolbar {...props}>
      <SaveButton submitOnEnter={true} disabled={disabled} />
      <Box sx={{width: 32}} />
      <SaveButton
        label={label}
        disabled={!(hasAllTranslations && hasAllVideos)}
        transform={data => ({ ...data, blocked: !(label == 'PUBLISH')})}
        submitOnEnter={false}
        variant="text"
      />
      <Box sx={{flex: 1}} />
      <DeleteButton />
    </Toolbar>
  )
};

const PreviewImage = ({ record, source }) => {
  if (typeof (record) == "string") {
    record = {
      [source]: `${record}`
    }
  }
  return <ImageField record={record} source={source} />
}

const PreviewFile = ({ record, source, title }) => {
  if (typeof (record) == "string") {
    record = {
      [title]: record,
      [source]: `${record}`
      // [source]: `${record}?t=${new Date()}`
    }
  }
  return <FileField record={record} source={source} title={title} target="_blank" />
}

const LessonEdit = (props) => {
  const dataProvider = useDataProvider();

  const [record, setRecord] = React.useState();
  const [divisions, setDivisions] = React.useState([]);
  const classes = useStyles();

  React.useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}/cms/divisions`)
      .then(res => res.json())
      .then(data => setDivisions(data))

      dataProvider.getOne('lessons', {id: props.id})
      .then(({data}) => {
        setRecord(data);
      })
      .catch(error => {
        // do something here
      })
  }, []);

  const dateFormatter = v => {
    const dateRegex = /^\d{4}-\d{2}-\d{2}/;
    if (dateRegex.test(v)) {
      return `${v}`.slice(0, 10)
    }

    return null;
  };

  let videoInputsDisabled = false
  if (record && `${record.name}.mp4` != record.file_name) {
    videoInputsDisabled = true
  }

  return (
    <Edit title="Edit lesson" {...props}>
      <TabbedForm toolbar={<LessonEditToolbar />}>
        <FormTab label="summary">
          <BooleanInput label="Blocked" source="blocked" />
          <TextInput source="name" disabled={true} label="Generic name" formClassName={clsx(classes.inline, 'first-child')} />
          <SelectInput source="division" label="Division" choices={divisions} validate={required()} formClassName={classes.inline} />
          <NumberInput source="xp" validate={required()} formClassName={classes.inline} />
          <BooleanInput label="Premium" source="premium" />
          <DateInput label="Data de ínicio" source="date_start" format={dateFormatter} formClassName={clsx(classes.inline, 'first-child')} />
          <DateInput label="Date de término" source="date_end" format={dateFormatter} formClassName={classes.inline} />
          <ImageInput label="Thumbnail" source="thumbnail">
            <PreviewImage source="src" />
          </ImageInput>
        </FormTab>

        <FormTab label="pt-BR">
          <TextInput label="Título (pt-BR)" source="ptbr_name" validate={required()} />
          <FileInput source="ptbr_video" label="Related files" accept="video/mp4" >
            <PreviewFile source="src" title="title" />
          </FileInput>
        </FormTab>

        <FormTab label="en-US">
          <TextInput label="Título (en-US)" source="enus_name" />
          <FileInput source="enus_video" label="Related files" accept="video/mp4" >
            <PreviewFile source="src" title="title" />
          </FileInput>
        </FormTab>

        <FormTab label="es-ES">
          <TextInput label="Título (es-ES)" source="es_name" />
          <FileInput source="es_video" label="Related files" accept="video/mp4" >
            <PreviewFile source="src" title="title" />
          </FileInput>
        </FormTab>

        {/* <FormTab label="hu-HU">
          <TextInput label="Título (hu-HU)" source="hu_name" />
          <FileInput source="hu_video" label="Related files" accept="video/mp4" >
            <PreviewFile source="src" title="title" />
          </FileInput>
        </FormTab> */}
      </TabbedForm>
    </Edit>
  );
}

export default LessonEdit;